import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CardCmp from 'src/components/CardCmp';
import TruncateTextCmp from 'src/components/TruncateText';
import { orderDetailsLoading } from 'src/redux/orders.slice';
import { usePhone } from 'src/utils/CommonFunctions';

interface IShipperAndConsigneeDetailsProps {
    title: string;
    data: {
        companyName: string;
        address: string;
        contactName: string;
        phoneNumber: string;
        email: string;
    };
}

const ShipperAndConsigneeDetails = ({ title, data }: IShipperAndConsigneeDetailsProps) => {
    const { t } = useTranslation();
    const { getFormatPhoneWithPlus } = usePhone();
    const loading = useSelector(orderDetailsLoading);
    const companyNameRef = useRef<HTMLHeadingElement>(null);
    const addressRef = useRef<HTMLParagraphElement>(null);
    const nameRef = useRef<HTMLParagraphElement>(null);
    const numberRef = useRef<HTMLParagraphElement>(null);
    const emailRef = useRef<HTMLParagraphElement>(null);

    return (
        <CardCmp headerTitle={title} headerParentClassName="!rounded-t-lg" cardClassName="w-full lg:w-[calc(50%_-_8px)] flex flex-col" childrenClassName="py-3 space-y-3 flex flex-col flex-1">
            <>
                <div className="border-b border-utilityGray200 pb-3 space-y-0.5">
                    <TruncateTextCmp message={loading ? '' : data?.companyName || '-'} refName={companyNameRef} truncateTextParentClassName="w-full">
                        <h6 className={`text-grayLight900 text-sm font-medium truncate ${loading ? 'custom-loading' : ''}`} ref={companyNameRef}>
                            {loading ? 'lorem ipsum dolor sit' : data?.companyName || '-'}
                        </h6>
                    </TruncateTextCmp>
                    <TruncateTextCmp message={loading ? '' : data?.address || '-'} refName={addressRef} truncateTextParentClassName="w-full">
                        <p className={`text-grayLight600 text-xs font-normal truncate ${loading ? 'custom-loading' : ''}`} ref={addressRef}>
                            {loading ? 'lorem ipsum dolor sit' : data?.address || '-'}
                        </p>
                    </TruncateTextCmp>
                </div>
                <div className="flex flex-col w-full space-y-1.5">
                    <div className="flex items-center gap-x-1 min-w-0">
                        <p className="text-grayLight600 text-xs leading-[18px] font-normal whitespace-nowrap text-nowrap">{t('Common.Contact_Name')}:</p>
                        <TruncateTextCmp message={loading ? '' : data?.contactName || '-'} refName={nameRef} truncateTextParentClassName="w-full">
                            <p className={`text-grayLight900 text-xs leading-[18px] font-medium truncate ${loading ? 'custom-loading w-20' : ''}`} ref={nameRef}>
                                {loading ? 'lorem ipsum' : data?.contactName || '-'}
                            </p>
                        </TruncateTextCmp>
                    </div>

                    <div className="flex max-lg:flex-col max-lg:gap-1.5 items-stretch w-full gap-x-3">
                        <div className="flex items-center gap-x-1 min-w-0 flex-1">
                            <p className="text-grayLight600 text-xs leading-[18px] font-normal text-nowrap">{t('Common.Email_Address')}:</p>
                            <div className={`flex items-center gap-x-1 min-w-0 ${loading ? 'custom-loading' : ''}`}>
                                <TruncateTextCmp message={loading ? '' : data?.email || '-'} refName={emailRef} truncateTextParentClassName="w-full">
                                    <p className="text-grayLight900 text-xs leading-[18px] font-medium truncate" ref={emailRef}>
                                        {loading ? 'lorem ipsum' : data?.email || '-'}
                                    </p>
                                </TruncateTextCmp>
                            </div>
                        </div>

                        <div className="w-px bg-utilityGray200 self-stretch max-lg:hidden"></div>

                        <div className="flex items-center gap-x-1 min-w-0 flex-1">
                            <p className="text-grayLight600 text-xs leading-[18px] font-normal whitespace-nowrap text-nowrap">{t('Common.Contact_Number')}:</p>
                            <div className={`flex items-center gap-x-1 min-w-0 ${loading ? 'custom-loading' : ''}`}>
                                <TruncateTextCmp message={loading ? '' : data?.phoneNumber ? getFormatPhoneWithPlus(data.phoneNumber) : '-'} refName={numberRef} truncateTextParentClassName="w-full">
                                    <p className={`text-grayLight900 text-xs leading-[18px] font-medium truncate ${loading ? 'w-20' : ''}`} ref={numberRef}>
                                        {loading ? 'lorem ipsum' : data?.phoneNumber ? getFormatPhoneWithPlus(data.phoneNumber) : '-'}
                                    </p>
                                </TruncateTextCmp>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </CardCmp>
    );
};

export default ShipperAndConsigneeDetails;
